import React, {Component} from 'react';
import ReactMarkdown from 'react-markdown'
import { StyledCard } from './style';
import {Link} from 'react-router-dom';
import moment from 'moment'
import { Card } from 'antd';
import { fetchCategoryPosts } from '../../actions/categories'
import { StyledContent } from '../../styles/mixins'

class PostCategories extends Component {

    state = {
        category: null,
    }

    async componentWillMount(){
        const postResponse = await fetchCategoryPosts(this.props.match.params.slug)
        if (postResponse && postResponse.data && postResponse.data.data && postResponse.data.data.categories && postResponse.data.data.categories.length > 0) {
            const category = postResponse.data.data.categories[0];
            let posts = (category && category.posts) || []
            if (posts.length > 1 && category.sortOrder === 'DateDecending') {
              const emptyPosts = posts.filter(a => !a.postDate);
              posts = posts.filter(a => a.postDate).sort((a, b) => {
                if (moment(a.postDate).isAfter(moment(b.postDate))) {
                  return -1;
                }
                return 1;
              })
              posts = posts.concat(emptyPosts);
            } else if (posts.length > 1 && category.sortOrder === 'DateAscending') {
              const emptyPosts = posts.filter(a => !a.postDate);
              posts = posts.filter(a => a.postDate).sort((a, b) => {
                if (moment(a.postDate).isBefore(moment(b.postDate))) {
                  return -1;
                }
                return 1;
              })
              posts = posts.concat(emptyPosts);
          } else if (posts.length > 1 && category.sortOrder === 'TitleAscending') {
              posts = category.posts.sort((a, b) => {
                if (a.title < b.title) {
                  return -1;
                }
                return 1;
              })
            } else if (posts.length > 1 && category.sortOrder === 'TitleDecending') {
              posts = category.posts.sort((a, b) => {
                if (a.title > b.title) {
                  return -1;
                }
                return 1;
              })
            }
            category.posts = posts;
            this.setState({
                category: category,
            })
        }
    }

    render() {
        const { category } = this.state
          const gridStyle = {
            width: '20%',
            textAlign: 'center',
            fontSize: 12,
          };
        return (
            <StyledContent>
                <Card title={category ? category.name : ''} bordered={false}>
                  {
                    category && category.posts && category.posts.map((post,i) => {
                      return category.hideTitleOnPosts ?
                        <Card.Grid className="sub-card" key={i} style={gridStyle}>
                          <Link
                            to={`/post/${post.slug}`}>{post.postDate ? moment(post.postDate.substr(0, 10)).format('MMM DD, YYYY') : ''}</Link>
                        </Card.Grid> :
                        <Card.Grid className="sub-card" key={i} style={{...gridStyle, width: '33.33%'}}>
                            <Link
                              to={`/post/${post.slug}`}>{post.title}<small style={{float: 'right', color: '#111'}}>{post.postDate ? moment(post.postDate.substr(0, 10)).format('MMM DD, YYYY') : ''}</small></Link>
                      </Card.Grid>
                    })
                  }
                </Card>
            </StyledContent>
        )
    }
}
export default PostCategories



// WEBPACK FOOTER //
// ./src/components/categories/postCategories.js